import _ from 'lodash';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { orgId, Ajax } from 'utils';
import * as actionTypes from 'state/actions/actionTypes';
import * as editProfileActions from 'state/actions/editProfileActions';
import * as currentUserSelectors from 'state/selectors/currentUserSelectors';

import { encode64, formatFormData } from 'utils/ebUtils';

const getUpdatedProfiles = (newProfileDetails, profile) => {
  if (_.isEmpty(newProfileDetails)) return profile;

  const updatedProfiles = {
    ...profile,
  };

  _.each(newProfileDetails, (value, fieldName) => {
    if (_.has(updatedProfiles, fieldName)) {
      updatedProfiles[fieldName].value = value;
    }
  });

  return updatedProfiles;
};

const formatProfileParams = (profiles, contactPaths) => {
  const ps = [];
  _.each(profiles, profile => {
    ps.push({ profileId: profile.profileId, name: profile.name, value: profile.value });
  });
  const data = { profile: encode64(JSON.stringify(ps)) };
  data.contactPath = encode64(JSON.stringify(contactPaths));

  return data;
};

export function* saveMyProfile({
  payload: { contactId, profile, contactPaths, successCallback, failCallback },
}) {
  try {
    const profiles = yield select(currentUserSelectors.selectProfiles);
    const updatedProfiles = getUpdatedProfiles(profile, profiles);
    const profileParams = formatProfileParams(updatedProfiles, contactPaths);
    const formattedParams = formatFormData(profileParams);
    const url = `/${orgId}/${contactId}/profile`;

    const { data: result } = yield call(Ajax.post, url, formattedParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (result.status === 'yes') {
      successCallback();
    } else {
      failCallback();
    }

    yield put(editProfileActions.saveMyProfile.success(result));
  } catch (error) {
    yield put(editProfileActions.saveMyProfile.fail({ saveMyProfile: 'saveMyProfileError' }));
  }
}

export function* watchSaveMyProfile() {
  yield takeLatest(actionTypes.SAVE_MY_PROFILE.ACTION, saveMyProfile);
}
